import React from 'react';

import ResponsiveImage from 'components/images/ResponsiveImage';
import {
  ScrollSection,
  BlackSlide,
  BigText,
  MedText,
  PhotoRow,
  PhotoGridRow,
  PressRow,
  PressItem,
  Fact,
  FactRow,
  Row,
  Spacer,
  SectionCaption
} from '../styles';

import { keyFacts, pressLogos } from 'data/home';

const generateFacts = () => {
  const rows = [];
  let cols = [];
  keyFacts.forEach((el, idx) => {
    cols.push(
      <Fact key={`fact-${idx}`} index={idx + 1}>
        <p className="fact-index">{idx + 1}</p>
        <p className="fact-body">{el}</p>
      </Fact>
    );
    if ((idx + 1) % 4 === 0) {
      rows.push(<FactRow key={`fact-${idx}`}>{cols}</FactRow>);
      cols = [];
    }
  });
  return rows;
};

const generatePressGrid = () => {
  const rows = [];
  let cols = [];

  pressLogos.forEach((el, idx) => {
    cols.push(
      <PressItem href={el.href} target="_blank" key={`row-${idx}-el-${idx}`}>
        <img src={el.logo} alt={`${el.alt} logo`} className="press-logo" />
      </PressItem>
    );

    if ((idx + 1) % 4 === 0) {
      rows.push(<PressRow key={`fact-${idx}`}>{cols}</PressRow>);
      cols = [];
    }
  });

  return rows;
};

const SectionThree = ({ revealed }) => {
  return (
    <React.Fragment>
      <BlackSlide className="swiper-slide" revealed={revealed >= 18}>
        <h1 className="quote">
          ROW DTLA has become the on the cusp cultural event epicenter of Downtown Los Angeles’ art,
          fashion, design, music and food scene.
        </h1>
      </BlackSlide>
      <ScrollSection className="swiper-slide" paddingLeft="120px" revealed={revealed >= 19}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_1"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <BigText className="black-500">
            A dynamic destination
            <br />
            molded through
            <br />
            curated, elevated
            <br />
            experiences
          </BigText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingLeft="120px" revealed={revealed >= 20}>
        <ResponsiveImage
          srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_2"
          imgAlt="test"
        />
      </ScrollSection>
      <ScrollSection
        className="swiper-slide"
        paddingLeft="120px"
        paddingRight="120px"
        revealed={revealed >= 21}
      >
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_3"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <MedText className="black-500">
            Gaining momentum as the
            <br />
            creative centerpiece of LA, ROW
            <br />
            DTLA sets the tone for a new spin
            <br />
            on offline experiences and a<br />
            luxurious lifestyle
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 22}>
        <Row height="55%" />
        <Row height="45%">
          <BigText>
            Unmatched level of
            <br />
            installations, events,
            <br />
            pop-ups, and more
          </BigText>
        </Row>
      </ScrollSection>
      <ScrollSection
        className="swiper-slide photo-grid"
        paddingRight="180px"
        revealed={revealed >= 23}
        spaceBetween
      >
        <PhotoGridRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_4"
            imgAlt="test"
          />
          <Spacer />
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_5"
            imgAlt="test"
          />
          <Spacer />
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_6"
            imgAlt="test"
          />
        </PhotoGridRow>
        <PhotoGridRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_7"
            imgAlt="test"
          />
          <Spacer />
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_8"
            imgAlt="test"
          />
          <Spacer />
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_9"
            imgAlt="test"
          />
        </PhotoGridRow>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 24}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_10"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <MedText>
            Monthly, weekly and daily events
            <br />
            constantly create unique interactions
            <br />
            connecting retailers to consumers, all
            <br />
            occurring at a thriving, open-air
            <br />
            mecca of contemporary culture
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 25}>
        <ResponsiveImage
          srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_11"
          imgAlt="test"
        />
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="0" revealed={revealed >= 26}>
        <Row height="55%" />
        <Row height="45%">
          <BigText className="grey-500">Key facts</BigText>
        </Row>
      </ScrollSection>
      <ScrollSection
        className="swiper-slide"
        revealed={revealed >= 27}
        paddingTop="20vh"
        paddingBottom="20vh"
        spaceBetween
      >
        {generateFacts()}
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingLeft="120px" revealed={revealed >= 28}>
        <Row height="55%" />
        <Row height="45%">
          <BigText className="grey-500">In the news</BigText>
        </Row>
      </ScrollSection>
      <ScrollSection
        className="swiper-slide"
        revealed={revealed >= 29}
        paddingTop="20vh"
        paddingBottom="20vh"
        spaceBetween
      >
        {generatePressGrid()}
        <SectionCaption style={{ position: 'absolute', bottom: '10vh' }}>
          Click to View Articles
        </SectionCaption>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingBottom="20vh" revealed={revealed >= 30}>
        <ResponsiveImage
          srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_12"
          imgAlt="Birds eye view of building"
        />
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="160px" revealed={revealed >= 31}>
        <Row height="55%" />
        <Row height="45%">
          <BigText className="black-500">
            ROW DTLA.
            <br /> Become part of the
            <br /> Evolution of Los Angeles
          </BigText>
        </Row>
      </ScrollSection>
    </React.Fragment>
  );
};

export default SectionThree;
